import { TFunction } from 'i18next'

/**
 * Known and applied error codes from Cognito Identity Provider.
 * @see https://docs.aws.amazon.com/AWSJavaScriptSDK/v3/latest/client/cognito-identity-provider/command/ConfirmForgotPasswordCommand
 */
const COGNITO_ERROR_CODES = [
  'CodeMismatchException',
  'ExpiredCodeException',
  'LimitExceededException',
  // Raised when the portal's password policy prevents reuse of a previous password
  'PasswordHistoryPolicyViolationException'
] as const

type CognitoErrorCode = (typeof COGNITO_ERROR_CODES)[number]

interface AuthError {
  code?: string
  name?: string
  message?: string
}

/** Gets a translated error message for auth-related errors. */
export const getAuthErrorMessage = (
  error: AuthError | null | undefined,
  t: TFunction
): string => {
  const errorCode = error?.code || error?.name

  if (
    errorCode &&
    COGNITO_ERROR_CODES.includes(errorCode as CognitoErrorCode)
  ) {
    const translationKey = `common.error.${errorCode}`
    // Disable fallback to prevent showing translations from other languages
    const translatedMessage = t(translationKey, { fallbackLng: [] })

    if (translatedMessage !== translationKey) {
      return translatedMessage
    }
  }

  return error?.message || t('common.error.something_went_wrong')
}
